import React from 'react'
import {connect} from 'react-redux'
import TopicProblemPage from '../components/TopicProblemPage'
import {chooseActiveProblem, makeSelectTopic, makeSelectProblems} from '../../../redux/modules/topic'
import {selectUserInfo} from '../../../redux/modules/session'
import {toJS} from '../../../util/ToJS'
import {showModal} from '../../../redux/modules/modal'
import {handleNewContent} from '../../../redux/modules/topic'
import {withRouter} from 'react-router'
import qs from 'query-string'

class VisibleTopicProblemPageComponent extends React.PureComponent {
  componentDidMount() {
    const {chooseActiveProblem, problemId} = this.props
    chooseActiveProblem(problemId)
  }
  componentWillReceiveProps(nextProps) {
    const {chooseActiveProblem, problemId} = this.props
    const {problemId: nextProblemId} = nextProps
    if (parseInt(problemId) !== parseInt(nextProblemId)) {
      chooseActiveProblem(nextProblemId)
    }
  }
  render() {
    return (
      <TopicProblemPage
        {...this.props}
      />
    )
  }
}

const makeMapStateToProps = () => {
  
  const selectTopic = makeSelectTopic()
  const selectProblems = makeSelectProblems(selectTopic)
  const mapStateToProps = state => {
    const problems = selectProblems(state)
    const userInfo = selectUserInfo(state)
    const isModerator = (userInfo.role === 'mod' || userInfo.role === 'admin')
    return {
      problems: problems,
      isLoggedIn: userInfo.isLoggedIn,
      isModerator: isModerator,
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = (dispatch, {topic, problemId, history}) => {
  return {
    chooseActiveProblem: problemId => {
      dispatch(chooseActiveProblem(problemId))
    },
    editProblemTopicTags: () => {
      dispatch(showModal('EDIT_PROBLEM_TOPIC_TAGS',{
        topic: topic,
        problemId: problemId,
      }))
    },
    createSolution: () => {
      dispatch(showModal('CONTENT_EDITOR',{
        contentOrTopicId: problemId,
        createOrEdit: 'create',
        contentType: 'problem_solution',
        handleNewContent: (newContent) => {
          dispatch(handleNewContent(topic.id, newContent))
          history.replace({
            search: qs.stringify(newContent)
          })
        }
      }))
    },
    createProblem: () => {
      dispatch(showModal('CONTENT_EDITOR',{
        contentOrTopicId: topic.id,
        createOrEdit: 'create',
        contentType: 'problem',
        handleNewContent: (newContent) => {
          dispatch(handleNewContent(topic.id, newContent))
          history.replace({
            search: qs.stringify(newContent)
          })
        }
      }))
    }
  }
}

const VisibleTopicProblemPage = withRouter(connect(
  makeMapStateToProps,
  mapDispatchToProps,
)(toJS(VisibleTopicProblemPageComponent)))

export default VisibleTopicProblemPage



// WEBPACK FOOTER //
// ./src/domains/topic/containers/VisibleTopicProblemPage.js